import {
  $albumCollectionsTableSearchInputValue,
  AlbumCollectionsTable,
  AlbumCollectionsTableGate,
  albumCollectionsTableQuery,
  albumCollectionsTableSearchChanged,
} from '@/entities/album-collections'
import { ROUTES, STRINGS } from '@/shared/config'
import { EmptyContent, HidingSpin } from '@/shared/ui'
import { PrimaryButton } from '@/shared/ui'
import { PlusOutlined, SearchOutlined } from '@ant-design/icons'
import { Button, Flex, Input, Space } from 'antd'
import { useUnit } from 'effector-react'
import { NavLink, useNavigate } from 'react-router-dom'

import type { AuthorEditorTabProps } from '..'

export const AuthorAlbumCollectionsTab = ({ author }: AuthorEditorTabProps) => {
  const navigate = useNavigate()

  const { data, pending, error } = useUnit(albumCollectionsTableQuery)

  const search = useUnit($albumCollectionsTableSearchInputValue)
  const changeSearch = useUnit(albumCollectionsTableSearchChanged)

  return (
    <>
      <AlbumCollectionsTableGate initialFilters={{ AuthorIds: [author.id] }} />
      <Flex justify="end" align="center" style={{ marginBottom: 24 }}>
        <Space>
          <Input
            placeholder={STRINGS.placeholder_search_by_name_input}
            allowClear
            addonAfter={<SearchOutlined />}
            value={search || ''}
            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
              const searchString = event.target.value
              changeSearch(searchString)
            }}
            style={{
              minWidth: 300,
            }}
          />
          <NavLink
            to={ROUTES.COLLECTIONS.CREATE_ALBUM_COLLECTION}
            state={{ author: author }}
          >
            <Button icon={<PlusOutlined />}>Создать</Button>
          </NavLink>
        </Space>
      </Flex>
      <HidingSpin spinning={pending || (!data?.items && !error)}>
        {data?.items && data.items.length > 0 ? (
          <AlbumCollectionsTable
            onEdit={(albumCollectionId: string) => {
              void navigate(
                ROUTES.COLLECTIONS.EDIT_ALBUM_COLLECTION.replace(
                  ':id',
                  albumCollectionId,
                ),
                { state: { author: author } },
              )
            }}
          />
        ) : search?.length && search?.length > 0 ? (
          <EmptyContent description={STRINGS.nothing_was_found} />
        ) : (
          <EmptyContent
            description="В списке пока нет ни одного выпуска"
            content={
              <Space>
                <NavLink
                  to={ROUTES.COLLECTIONS.CREATE_ALBUM_COLLECTION}
                  state={{ author: author }}
                >
                  <PrimaryButton>Создать выпуск</PrimaryButton>
                </NavLink>
              </Space>
            }
          />
        )}
      </HidingSpin>
    </>
  )
}
